import Swal from 'sweetalert2'
import { nanoid } from 'nanoid/async'

import { lang } from '../../assets/lang'
import { httpApiHtml } from './httpApiHtml'
import { 
  sweetAlertCommonParams,
} from '../../utils/functions'

const instagram_addon = window.xitFlowBuilderData.instagram_addon
var media_type = 'fb'
if (instagram_addon) media_type = 'ig'

var http_api_create = window.xitFlowBuilderData.base_url+'http_api/build_api?channel='+media_type
var http_api_edit = window.xitFlowBuilderData.base_url+'http_api/build_api?id='
var http_api_report = window.xitFlowBuilderData.base_url+'http_api/list_api_report_all?id='
var get_http_api_list_url = window.xitFlowBuilderData.base_url+'visual_flow_builder/get_http_api_dropdown/'+media_type


// eslint-disable-next-line
export const httpApiModal = async (oldData, node) => {

  const commonParams = sweetAlertCommonParams(node)
  
  return await Swal.fire({
    ...commonParams,
    title: lang.http_api_modal_title,
    html: httpApiHtml,

    willOpen: () => {
      $('.select2').select2({ 
        width: '100%',
        dropdownParent: $('#swal2-content')
      })

      const httpApiElement = $('#http-api-table-id')
      if (oldData.httpApiId) {
        $("#http-api-edit-link").removeClass('d-none').attr('href',http_api_edit+oldData.httpApiId)
        $("#http-api-report-link").removeClass('d-none').attr('href',http_api_report+oldData.httpApiId)
      }
      else {
        $("#http-api-edit-link").addClass('d-none')
        $("#http-api-report-link").addClass('d-none')
      }

      httpApiElement.on('change', function(e) {
        const currentValue = e.target.value
        if (currentValue) {
          $("#http-api-edit-link").removeClass('d-none').attr('href',http_api_edit+currentValue)
          $("#http-api-report-link").removeClass('d-none').attr('href',http_api_report+currentValue)
        }
      })
      get_http_api_list()
      $("#refresh-list").on('click', function (e){
        get_http_api_list()
      })

      function get_http_api_list() {
        $.ajax({
            context:this,
            url: get_http_api_list_url,
            type:'GET',
            dataType: 'json',
            data:{},
            beforeSend: function (xhr) {
                xhr.setRequestHeader('X-CSRF-TOKEN', window.xitFlowBuilderData.csrf_token);
            },
            success:function(response){
                if(response.status === '1'){
                  httpApiElement.html(response.dropdown_str)
                  httpApiElement.val(oldData.httpApiId || '').trigger('change')
                }
                else {
                  return Swal.showValidationMessage(lang.http_api_modal_error_msg)
                }
            },
            error: function() {
            }
        });
      }
      

    },

    preConfirm: () => {

      const httpApiId = $('#http-api-table-id').val() || null
      const httpApiText = $('#http-api-table-id option:selected').text() || null
      if (! httpApiId) {
        return Swal.showValidationMessage(lang.http_api_modal_error_msg)
      }
  
      return {
        httpApiId,
        httpApiText,
      }
    },    
  })
}